import type { Experiment, Result } from "@growthbook/growthbook";

import { createArgusEvent, createGtmEvent } from "@solvari/argus";

async function addAbTestEvent(
  experiment: Experiment<unknown>,
  result: Result<unknown>,
) {
  await Promise.all([
    createGtmEvent("experiment_impression", {
      variantId: result.key,
      experimentId: experiment.key,
    }),
    createArgusEvent("google_optimize", {
      variantId: result.key,
      experimentId: experiment.key,
    }),
  ]);
}

export { addAbTestEvent };
